import React from "react"

import {
  FacebookIcon,
  TwitterIcon,
  WhatsappIcon,
  EmailIcon,
  FacebookShareButton,
  WhatsappShareButton,
  TwitterShareButton,
  EmailShareButton,
} from "react-share"

/*
 * This component is built using `gatsby-image` to automatically serve optimized
 * images with lazy loading and reduced file sizes. The image is loaded using a
 * `StaticQuery`, which allows us to load the image from directly within this
 * component, rather than having to pass the image data down from pages.
 *
 * For more information, see the docs:
 * - `gatsby-image`: https://gatsby.dev/gatsby-image
 * - `StaticQuery`: https://gatsby.dev/staticquery
 */

const SocialShare = ({ title, href }) => {
  const iconsize = 30

  return (
    <div className="d-flex flex-row">
      <FacebookShareButton url={href} className="button p-1">
        <FacebookIcon size={iconsize} />
      </FacebookShareButton>

      <TwitterShareButton url={href} className="button p-1">
        <TwitterIcon size={iconsize} />
      </TwitterShareButton>

      <WhatsappShareButton url={href} className="button p-1">
        <WhatsappIcon size={iconsize} />
      </WhatsappShareButton>

      <EmailShareButton subject={title} url={href} className="button p-1">
        <EmailIcon size={iconsize} />
      </EmailShareButton>
    </div>
  )
}
export default SocialShare
